export default __webpack_public_path__ + "static/Asset 11@300x-80dcd1277a1dfe40b63459f3a51aa284.png";